import React, { useCallback, useContext } from 'react';
import { GridContext } from '@bingads-webui-grid/grid-context';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import {
  Button,
  Caption1,
  Divider,
  makeStyles,
  Select,
  useId,
} from '@fluentui/react-components';
import {
  ArrowLeftRegular,
  ArrowRightRegular,
} from '@fluentui/react-icons';

const useStyles = makeStyles({
  root: {
    alignItems: 'center',
    columnGap: '15px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  pageNumber: {
    marginRight: '4px',
    maxWidth: '32px',
  },
});

const pageSizeOptions = [
  10,
  25,
  50,
];

export const Paginator = () => {
  const i18n = useContext(I18nContext);
  const styles = useStyles();

  const { dispatch, state } = useContext(GridContext);
  const { pageNumber, pageSize } = state.pagination;

  const pageSizeId = useId();
  const pageSizeLabel = i18n.getString(_TL_('Rows per page:'));
  const pageCount = Math.ceil(state.totalCount / pageSize);
  const pageCountSeparator = i18n.getString(_TL_('of'));

  const onSelectPageSize = useCallback((e, { value }) => {
    dispatch({
      type: 'UPDATE_PAGINATION',
      payload: {
        pageNumber: 1,
        pageSize: Number(value),
      },
    });
  }, [dispatch]);

  const onDecreasePageNumber = useCallback(() => {
    if (pageNumber > 1) {
      dispatch({
        type: 'UPDATE_PAGINATION',
        payload: {
          ...state.pagination,
          pageNumber: pageNumber - 1,
        },
      });
    }
  }, [dispatch, state.pagination, pageNumber]);

  const onIncreasePageNumber = useCallback(() => {
    dispatch({
      type: 'UPDATE_PAGINATION',
      payload: {
        ...state.pagination,
        pageNumber: pageNumber + 1,
      },
    });
  }, [dispatch, state.pagination, pageNumber]);

  return (
    <div className={styles.root}>
      <Caption1>{pageSizeLabel}</Caption1>
      <Select
        appearance="outline"
        id={pageSizeId}
        onChange={onSelectPageSize}
        size="small"
        value={pageSize}
      >
        {pageSizeOptions.map(pageSizeOption => (
          <option key={pageSizeOption}>{pageSizeOption}</option>
        ))}
      </Select>
      <Divider vertical />
      <Button
        appearance="subtle"
        disabled={pageNumber === 1}
        icon={<ArrowLeftRegular />}
        onClick={onDecreasePageNumber}
        size="small"
      />
      <Caption1>{`${pageNumber} ${pageCountSeparator} ${pageCount}`}</Caption1>
      <Button
        appearance="subtle"
        disabled={pageNumber === pageCount}
        icon={<ArrowRightRegular />}
        onClick={onIncreasePageNumber}
        size="small"
      />
    </div>
  );
};
